export const studyTypeOptions = [
  { label: "Market Insights Study", value: "market_insights_study" },
  { label: "Preference Study", value: "preference_study" },
  { label: "Expert Review", value: "expert_review" },
  { label: "Formative Usability Study", value: "formative_usability_study" },
  { label: "HF Pre-Validation Study", value: "hf_pre_validation_study" },
  { label: "HF Validation Study", value: "hf_validation_study" },
  { label: "Observational Study", value: "observational_study" },
  { label: "Interventional Study", value: "interventional_study" },
  { label: "Patient Database", value: "patient_registry" },
];
